import CrossFade from './CrossFade'

export default CrossFade
